import React, { Component } from 'react';

class YouTube extends Component {
  constructor(props) {
    super(props);
    this.video = React.createRef();
    this.state = { ...props };
    this.analyticsHit = this.analyticsHit.bind(this);
  }

  analyticsHit() {
    const { title, dataLayer } = this.state;
    if (dataLayer) {
      dataLayer.push({
        event: 'evan craft watch',
        eventLabel: title,
        ministry: 'The Soul Of A Song With Evan Craft',
      });
    }
  }

  render() {
    const { src } = this.state;
    const vidSource = `https://www.youtube.com/embed/${src}?autoplay=1&rel=0&modestbranding=0`;
    return (
      <div className="video-container">
        <iframe
          onLoad={this.analyticsHit}
          className="player"
          title={`vid-${src}`}
          type="text/html"
          width="100%"
          height="100%"
          src={vidSource}
          frameBorder="0"
          allowFullScreen
        />
      </div>
    );
  }
}

export default YouTube;



// WEBPACK FOOTER //
// ./src/components/YouTube.jsx